import React from "react";
import Phone from "./Phone";
import useCountUp from "../hooks/useCountUp";

/** Saved's home screen, running. */
export default function ScreenSaved({ active }) {
  const money = useCountUp(1595, active, { duration: 2100, delay: 300 });
  const days = useCountUp(23, active, { duration: 1300, delay: 460 });
  const goal = useCountUp(1380, active, { duration: 2100, delay: 700 });

  return (
    <Phone tint="#57b0f0" label="The Saved home screen: $1,595 kept and 23 days gambling-free.">
      <div className={`ui ui--saved${active ? " is-live" : ""}`}>
        <header className="ui__top">
          <div>
            <span className="ui__kicker">Gambling-free</span>
            <strong className="ui__h">{days} days</strong>
          </div>
          <span className="ui__shield" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 2.6 20 6v6.2c0 4.6-3.3 7.9-8 9.2-4.7-1.3-8-4.6-8-9.2V6l8-3.4Z" />
            </svg>
          </span>
        </header>

        <section className="ui__money">
          <span className="ui__label">Money kept</span>
          <strong>
            <i>$</i>
            {money.toLocaleString()}
          </strong>
          <span className="ui__delta">+ $69 today · that&rsquo;s a month in Japan. Twice.</span>
        </section>

        <section className="ui__chart">
          <svg viewBox="0 0 200 68" preserveAspectRatio="none" aria-hidden="true">
            <defs>
              <linearGradient id="savedFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#57d43f" stopOpacity="0.42" />
                <stop offset="100%" stopColor="#57d43f" stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              className="ui__chart-area"
              d="M0 62 L0 56 C24 54 34 50 52 44 C72 37 84 39 104 31 C126 22 138 24 158 15 C176 7 188 6 200 3 L200 62 Z"
              fill="url(#savedFill)"
            />
            <path
              className="ui__chart-line"
              d="M0 56 C24 54 34 50 52 44 C72 37 84 39 104 31 C126 22 138 24 158 15 C176 7 188 6 200 3"
            />
          </svg>
          <div className="ui__chart-axis">
            {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
              <span key={`${d}-${i}`}>{d}</span>
            ))}
          </div>
        </section>

        <section className="ui__breathe">
          <span className="ui__breathe-orb" aria-hidden="true">
            <i />
          </span>
          <span className="ui__breathe-txt">
            <b>Urge right now?</b>
            <i>In for four, hold two, out for six.</i>
          </span>
        </section>

        <section className="ui__goal">
          <div className="ui__goal-head">
            <span className="ui__label">Japan, next spring</span>
            <span className="ui__goal-num">${goal.toLocaleString()} / $3,600</span>
          </div>
          <span className="ui__bar">
            <i style={{ transform: `scaleX(${goal / 3600})` }} />
          </span>
        </section>

        <nav className="ui__tabs" aria-hidden="true">
          {["Today", "Money", "Circle", "You"].map((t, i) => (
            <span key={t} data-on={i === 0 || undefined}>
              {t}
            </span>
          ))}
        </nav>
      </div>
    </Phone>
  );
}
